import { Flex } from '@repo/ui/Flex';
import { Box } from '@repo/ui/Box';

import s from './ReasonsLayout.module.css';
import { Layout } from '../../components/Layout/Layout';
import { useWorkflow } from '../../workflow/hooks';
import { Step } from '../../components/Step/Step';
import { Page } from '../../components/Page/Page';
import { Text } from '../../components/Language/Language';
import { OverrideBanner } from '../../components/OverrideBanner/OverrideBanner';

export const ReasonsLayout = () => {
  const { data } = useWorkflow();
  const selectedItems = Object.keys(data?.items || {});

  if (selectedItems.length === 0) {
    return <Layout>No items selected. Please go back.</Layout>;
  }

  return (
    <Page>
      <Layout>
        <Box isContainer>
          <Flex
            direction="column"
            gap={['md:g-48', 'g-32']}
            padding={['md:px-0', 'px-16']}
          >
            <OverrideBanner />
            <div className={s.headerContainer}>
              <h1 className={s.header}>
                <Text langKey="Global.reasons.Header" />
              </h1>
              <div className={s.subheader}>
                <Text langKey="Global.reasons.Subheader" />
              </div>
            </div>
            <div className={s.content}>
              <Step formId="ReasonsStepForm" className={s.layout} />
            </div>
          </Flex>
        </Box>
      </Layout>
    </Page>
  );
};
